var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regist-success"},[_c('img',{attrs:{"src":require("@/assets/img/dq/reg_success.png")}}),_c('p',[_vm._v("您已成功完成发票签收")])])
}]

export { render, staticRenderFns }